// extracted by mini-css-extract-plugin
export default {"checkContainer":"w0evXuNGgn58YJQrZIcw","checkBox":"mW0YXvNQQOIS9yV1S_jw","checkBoxText":"up19ASE8RdViek3HrK5m","checkBoxLink":"yoTQ_Bwk9ShddpktlDt9"};